/**
 * Enhanced Invoice Management Page
 * Admin page for advanced invoice management features
 */

import React from 'react';
import { AdminRoute } from '../../components/auth/AdminRoute';
import EnhancedInvoiceDashboard from '../../components/invoices/EnhancedInvoiceDashboard';

const EnhancedInvoiceManagementPage = () => {
  return (
    <AdminRoute>
      <EnhancedInvoiceDashboard />
    </AdminRoute>
  );
};

export default EnhancedInvoiceManagementPage;
